export default "__VITE_ASSET__BhTm8BCF__"